import React from 'react';
import { useDarkMode } from '../DarkModeContext';

const DarkModeToggle = () => {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <button
      onClick={toggleDarkMode}
      className="relative inline-flex h-9 w-9 items-center justify-center rounded-full transition-colors duration-300 focus:outline-none focus:ring-1 focus:ring-neutral-500 focus:ring-offset-1 dark:focus:ring-offset-[#1a1a1a]"
      style={{
        border: 'none',
        backgroundColor: isDarkMode ? 'rgba(82, 82, 82, 0.3)' : 'white',
        boxShadow: isDarkMode ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)',
      }}
    >
      <span
        className="inline-block"
      >
        {/* Sun icon for light mode */}
        {!isDarkMode && (
          <svg
            className="h-3 w-3 opacity-50"
            style={{ color: '#955821' }}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
              clipRule="evenodd"
            />
          </svg>
        )}
        {/* Moon icon for dark mode */}
        {isDarkMode && (
          <svg
            className="h-3 w-3 text-[#D4D4D4] opacity-30"
            fill="currentColor"
            viewBox="0 0 20 20"
            style={{ display: 'block', margin: 'auto' }}
          >
            <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
          </svg>
        )}
      </span>
    </button>
  );
};

export default DarkModeToggle; 